import { FunctionComponent } from 'react';
import { usePlayground } from '@playground/context/hooks';
import Title from '@playground/components/Title';
import CodeEditor from '@playground/SQL/components/CodeEditor';
import PyodideProvider from '@playground/SQL/context';
import Tabs from './Tabs';

const Layout: FunctionComponent = () => {
  const { runner, exercise } = usePlayground();
  return (
    <PyodideProvider
      entryFile={exercise.entryFile}
      files={runner.showSolution ? exercise?.filesSolution : exercise?.files}
    >
      <div className="flex flex-col md:flex-row w-full h-full">
        <div className="w-full md:w-3/5 h-full">
          <div className="flex flex-col w-full h-full ">
            {exercise && <Title title={exercise.title} isSolved={exercise.done ?? false} />}
            <CodeEditor />
          </div>
        </div>
        <div className="flex flex-col w-full md:w-2/5 pl-0 md:pl-6 text-platzi-gray mt-8 md:mt-0 relative">
          <Tabs />
        </div>
      </div>
    </PyodideProvider>
  );
};

export default Layout;
